export default __webpack_public_path__ + "static/media/chat-red.9a26f4e3.svg";